<template>
  <div>
    <my-header></my-header>
  
    <div class="content-container-level-1">
      <div class="h-panel">
        <b-button v-b-modal.help-modal>Help</b-button>

        <b-button
          v-if="mayStartMesa"
          :to="{name: 'new_mesa'}"
          variant="primary"
        >
          New mesa
        </b-button>

      </div>

      <h2>Mesas</h2>

      <loading-indicator v-if="isLoading"/>

      <p v-if="message !== null">
        {{message}}
      </p>

      <table v-if="mesas !== null && mesas.length > 0" class="table table-bordered text-nowrap">
        <thead class="thead-dark">
          <tr>
            <th scope="col" rowspan="2">Name</th>
            <th scope="col" rowspan="2">Type</th>
            <th scope="col" rowspan="2">Audience</th>
            <th scope="col" rowspan="2">Status</th>
            <th scope="col" colspan="2" class="text-center">Start</th>
            <th scope="col" rowspan="2">Remaining time</th>
            <th scope="col" rowspan="2">Join available until</th>
            <th scope="col" colspan="2" class="text-center">Finish</th>
            <th scope="col" rowspan="2" v-if="mayManageMesas">Actions</th>
          </tr>
          <tr>
            <th scope="col">planned</th>
            <th scope="col">real</th>
            <th scope="col">planned</th>
            <th scope="col">real</th>
          </tr>
        </thead>
        <tr
          v-for="mesa in mesas"
          :key="mesa.id"
          :class="getMesaClass(mesa.status)"
        >
          <td>
            <mesa-link :mesaId="mesa.id" />
          </td>
          <td><b>{{mesa.protoId | getMesaTypeName}}</b></td>
          <td>
            <span v-b-popover.hover.top="getPlayerGroupDescription(mesa.playerGroupId)">
              {{mesa.playerGroupId | getPlayerGroupName}}
            </span>
          </td>
          <td :class="getMesaStatusClass(mesa.status)">
            {{mesa.status | getEnumMesaStatusNameFormatted}}
          </td>
          <td>{{mesa.stime | getMomentStr}}</td>
          <td>{{mesa.srtime | getMesaStartRealTimeStr}}</td>
          <td>{{getRemainingTimeStr(mesa)}}</td>
          <td>{{ mesa.ftime - mesa.prohibition_interval | getMomentMinStr }}</td>
          <td>{{mesa.ftime | getMomentStr}}</td>
          <td>{{mesa.frtime | getMesaFinishRealTimeStr}}</td>
          <td v-if="mayManageMesas" class="action-box">
            <b-button
              v-if="mustShowFinishButton(mesa)"
              @click="finalizeMesaWithConfirmation(mesa)"
              variant="warning"
              size="sm"
            >
              Finish
            </b-button>
            <b-button
              v-if="mayDeleteMesa"
              @click="removeMesaWithConfirmation(mesa)"
              variant="danger"
              size="sm"
            >
              Delete
            </b-button>
          </td>
        </tr>
      </table>

    </div>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показаны все mesa.
        </p>
        <p>
          В игре могут быть разные типы mesa.
          Сейчас реализованы: сиротка, птенец, торт, вышевка, скульптура.
        </p>

        <h6>Сиротка, птенец</h6>
        <p>
          Используют две линейти уровней, какая из них активная для игрока опраделяется по уровню основной линейки
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth.js';
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';
import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import MesaLink from './MesaLink.vue';

import { getPlayerGroupName                   } from '../model/event.js';
import { getPlayerGroupDescription            } from '../model/event.js';

import { MESA_STATUS_CLOSED                   } from '../model/mesa.js';
import { getMesaStatusClass                   } from '../model/mesa.js';
import { getMesaRemainingTimeStr              } from '../model/mesa.js';
import { getMesaStartRealTimeStr              } from '../model/mesa.js';
import { getMesaFinishRealTimeStr             } from '../model/mesa.js';
import { getMesaTypeName                      } from '../model/mesa.js';
import { getEnumMesaStatusNameFormatted       } from '../model/mesa.js';
import { isMesaActive                         } from '../model/mesa.js';
import { isMesaClosed                         } from '../model/mesa.js';

import { confirmAction                        } from '../service/confirm.js';

import { mayStartMesa as utilMayStartMesa     } from '../util.js';
import { mayFinalizeMesa                      } from '../util.js';
import { mayDeleteMesa  as utilMayDeleteMesa  } from '../util.js';
import { mayManageMesas as utilMayManageMesas } from '../util.js';
import { arrayDeleteFirstItemByValue          } from '../util.js';

export default {
  name: 'Mesas',

  components: {
    MyHeader,
    LoadingIndicator,
    MesaLink,
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      mesas: null,

      timerId: null,
      nowSec: Date.now() / 1000,
    };
  },

  computed: {
    message() {
      if(this.mesas !== null && this.mesas.length === 0) {
        return 'No mesas.';
      }
      return null;
    },

    mayStartMesa() {
      return utilMayStartMesa(this.actor.role);
    },

    mayDeleteMesa() {
      return utilMayDeleteMesa(this.actor.role);
    },

    mayManageMesas() {
      return utilMayManageMesas(this.actor.role);
    },
  },

  created() {
    this.timerId = setInterval(this.updateTime, 1000);
    this.loadMesas();
  },

  beforeDestroy() {
    if(this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },

  methods: {
    loadMesas() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = '/mesas';
      HTTP.get(url)
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const mesas = data;
        mesas.sort((a, b) => b.stime - a.stime);

        this.mesas = mesas;
      })
      .catch(err => {
        this.isLoading = false;
        notifier.showError(err);
      });
    },

    updateTime() {
      this.nowSec = Date.now() / 1000;
    },

    getRemainingTimeStr(mesa) {
      return getMesaRemainingTimeStr(mesa, this.nowSec);
    },

    getPlayerGroupDescription,

    getMesaStatusClass,

    getMesaClass(status) {
      return {
        closed: isMesaClosed(status)
      };
    },

    mustShowFinishButton(mesa) {
      if(!mayFinalizeMesa(this.actor.role)) {
        return false;
      }
      return isMesaActive(mesa.status);
    },

    finalizeMesaWithConfirmation(mesa) {
      this.confirmMesaFinalization(() => {
        this.finalizeMesa(mesa);
      });
    },

    removeMesaWithConfirmation(mesa) {
      this.confirmMesaRemoval(() => {
        this.removeMesa(mesa);
      });
    },

    // function onConfirmed()
    confirmMesaRemoval(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to delete this mesa {env}?',
        'Delete',
        onConfirmed,
      );
    },

    confirmMesaFinalization(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to finish this mesa {env}?',
        'Finish',
        onConfirmed,
      );
    },

    finalizeMesa(mesa) {
      notifier.deleteSenderNotifications(this);
      
      const url = `/mesa/${mesa.id}/finalize`;
      HTTP.post(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        mesa.frtime = data.frtime;
        mesa.status = MESA_STATUS_CLOSED;
        notifier.showSuccess('Mesa finished.');
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },

    removeMesa(mesa) {
      notifier.deleteSenderNotifications(this);
      
      const url = `/mesa/${mesa.id}/del`;
      HTTP.post(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        arrayDeleteFirstItemByValue(this.mesas, mesa);
        notifier.showSuccess('Mesa deleted.');
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },

  },

  filters: {
    getPlayerGroupName,
    getMesaTypeName,
    getEnumMesaStatusNameFormatted,
    getMesaStartRealTimeStr,
    getMesaFinishRealTimeStr, 
  },
};
</script>

<style scoped>
.closed {
  color: #dcdcdc;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
